import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import SEO from "@/components/SEO";
import PhilosophySection from "@/components/PhilosophySection";
import OurMission from "@/components/OurMission";
import DestinationsSection from "@/components/DestinationsSection";
import ServicesGrid from "@/components/ServicesGrid";
import BrandStatement from "@/components/BrandStatement";
import InquirySection from "@/components/InquirySection";
import Footer from "@/components/Footer";
import SplashScreen from "@/components/SplashScreen";
import StickyContact from "@/components/StickyContact";

const Index = () => {
  return (
    <SplashScreen>
      <div className="bg-background">
        <SEO
          title="Arzani Group — Luxury Concierge in Ibiza, Marbella, Saint-Tropez & Paris"
          description="Private yachts, exceptional residences, prestige vehicles and bespoke lifestyle across distinguished destinations."
          path="/"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Arzani Group",
            url: "https://arzanigroupworldwide.com",
            logo: "https://arzanigroupworldwide.com/images/logo-hero.webp",
            email: "info@arzanigroupworldwide.com",
            sameAs: ["https://www.instagram.com/arzanigroup"],
          }}
        />
        <Navigation />
        <HeroSection />
        <PhilosophySection />
        <DestinationsSection />
        <ServicesGrid />
        <OurMission />
        <BrandStatement />
        <InquirySection />
        <Footer />
        <StickyContact />
      </div>
    </SplashScreen>
  );
};

export default Index;
